import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0038',
    ecrans: ['00-2'],
    params: ['id',
            '?el1cleint',
            '?prucleint',
            '?prbcleint',
            '?vaesysnatctb',
            '?peccleintdeb',
            '?peccleintfin',
            '?indcleint']
});
